window.addEventListener('DOMContentLoaded', () => {
  // Only run on category pages
  if (document.body.classList.contains('category')) {
    const filterSection = document.querySelector('#filter');
    if (filterSection) {
      filterSection.scrollIntoView({ behavior: 'smooth' });
    }
  }
});
